<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="email-input">Username (ID)</label><span class="required"></span>
          <input (blur)="checkUserEmail($event)"
                 [disabled]="userInfo?.username"
                 class="form-control"
                 formControlName="username"
                 id="email-input"
                 placeholder="Email"
                 type="text">
        </div>
        <dp-field-error [formField]="form['username']"></dp-field-error>
      </div>

      <div class="col-md-6">
        <div class="mb-3 position-relative">
          <button (click)="togglePasswordFields()" [class.btn-secondary]="showPasswordFields" [class.btn-primary]="!showPasswordFields" class="btn ml-2" type="button">
            {{ showPasswordFields ? 'Hide Password Fields' : 'Change Password' }}
          </button>
        </div>
        <div class="mb-3 position-relative d-flex flex-row">
          <button (click)="unlockAccountModalOpen()" *ngIf="this.userInfo?.lockUntil && this.isAdmin"
                  class="btn btn-dark" type="button">
            <font-awesome style="color:white">Unlock User</font-awesome>
          </button>
        </div>
      </div>
    </div>

    <!-- Password Change Form Fields -->
    <div *ngIf="showPasswordFields" [formGroup]="passwordForm">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="newPassword-input">New Password</label><span class="required"></span>
            <input class="form-control" formControlName="newPassword" id="newPassword-input" placeholder="Enter new password" type="password">
          </div>
          <dp-field-error [formField]="passwordFormControls['newPassword']"></dp-field-error>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="confirmPassword-input">Confirm Password</label><span class="required"></span>
            <input class="form-control" formControlName="confirmPassword" id="confirmPassword-input" placeholder="Confirm new password" type="password">
          </div>
          <dp-field-error [formField]="passwordFormControls['confirmPassword']"></dp-field-error>
          <div *ngIf="passwordFormControls['confirmPassword']?.errors?.['passwordMismatch'] && passwordFormControls['confirmPassword']?.touched" class="text-danger" style="font-size: 12px; margin-top: -10px;">
            Passwords do not match
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3 position-relative d-flex justify-content-end" style="gap: 10px;">
            <button (click)="submitPasswordChange()" class="btn btn-success" type="button">
              Save New Password
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="firstName-input">First Name</label><span class="required"></span>
          <input class="form-control" formControlName="firstName" id="firstName-input" placeholder="First Name"
                 type="text">
        </div>
        <dp-field-error [formField]="form['firstName']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="lastName-input">Last Name</label><span class="required"></span>
          <input class="form-control" formControlName="lastName" id="lastName-input" placeholder="Last Name"
                 type="text">
        </div>
        <dp-field-error [formField]="form['lastName']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="tel-input">Phone Number</label><span class="required"></span>
          <input class="form-control phone-number"
                 formControlName="tel"
                 id="tel-input"
                 placeholder="Phone Number"
                 type="text"

          >
          <input class="form-control phone-number-ext ml-8px"
                 formControlName="ext"
                 id="ext-input"
                 placeholder="Ext."
                 type="text"
          >
        </div>
        <dp-field-error [formField]="form['tel']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="status-input">Status</label><span class="required"></span>
          <!--          <input type="text" class="form-control" id="status-input" formControlName="status"-->
          <!--                 placeholder="Status">-->
          <div>
            <ng-select [items]="statusGroupOptions"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="status"
                       id="status-input"
                       placeholder="Select User Status">
            </ng-select>
          </div>
        </div>
        <dp-field-error [formField]="form['status']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="userType-input">User Type</label><span class="required"></span>
          <!--          <input type="text" class="form-control" id="userType-input" formControlName="userType"-->
          <!--                 placeholder="User Type">-->
          <ng-select (change)="selectUserType($event);"
                     [items]="userTypeGroupOptions"
                     [multiple]="false"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control"
                     formControlName="userType"
                     id="userType-input"
                     placeholder="Select User Type"

          >
          </ng-select>
        </div>
        <dp-field-error [formField]="form['userType']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="organization-input">Organization</label><span class="required"></span>
          <!--          <input type="text" class="form-control" id="company-input" formControlName="company"-->
          <!--                 placeholder="Company">-->
          <div>
            <ng-select [items]="organizationGroupOptions"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="organization"
                       id="organization-input"
                       placeholder="Select Organization"
            >
            </ng-select>
          </div>
        </div>
        <dp-field-error [formField]="form['organization']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="roles-input">Roles</label><span class="required"></span>
          <div>
            <ng-select [items]="groupOptions"
                       [multiple]="true"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="roles"
                       id="roles-input"
                       placeholder="Select Roles">
            </ng-select>
          </div>
        </div>
      </div>
      <dp-field-error [formField]="form['roles']"></dp-field-error>
    </div>

    <div *ngIf="isAdminSelect" class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="selectHQStore-input">Stores</label><span class="required"></span>
          <div>
            <ng-select [items]="storeGroupOptions"
                       [multiple]="true"
                       bindLabel="name"
                       class="form-control"
                       formControlName="hqStores"
                       id="selectHQStore-input"
                       placeholder="Select HQ Stores">
            </ng-select>
          </div>
        </div>
      </div>
      <dp-field-error [formField]="form['roles']"></dp-field-error>
    </div>

    <div *ngIf="[loginCompanies.Seca].includes(company)" class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="firstName-input">Employee No</label>
          <input class="form-control" formControlName="employeeNo" id="employeeNo-input" placeholder="Employee No"
                 type="text">
        </div>
        <dp-field-error [formField]="form['employeeNo']"></dp-field-error>
      </div>
    </div>

    <div class="row dateRow">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="createdAt-input">Create Date</label>
          <input class="form-control" formControlName="createdAt" id="createdAt-input" placeholder="Create Date"
                 type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="updatedAt-input">Last Login</label>
          <input class="form-control" formControlName="updatedAt" id="updatedAt-input" placeholder="Last Login"
                 type="text">
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!simpleEdit">
      <div class="col-md-6">
        <div class="mb-3 position-relative">
          <input
            class="form-check-input"
            formControlName="optOut"
            id="dealerStoreAll" type="checkbox"/>
          <label class="form-check-label pl-4x" for="dealerStoreAll">I don't want to get message from Samsung.</label>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!simpleEdit">
      <div class="col-md-6">
        <div class="mb-3 position-relative">
          <input
            class="form-check-input"
            formControlName="doNotAllowComment"
            id="doNotAllowComment" type="checkbox"/>
          <label class="form-check-label pl-4x" for="doNotAllowComment">Don't allow add comment function</label>
        </div>
      </div>
      <div class="col-md-6" *ngIf="isSysAdmin || isAdmin">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="status-input">Avoid MFA</label><span class="required"></span>
          <div>
            <ng-select [items]="avoidMfaOptions"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="avoidMfa"
                       id="status-input"
                       placeholder="Avoid MFA">
            </ng-select>
          </div>
        </div>
        <dp-field-error [formField]="form['avoidMfa']"></dp-field-error>
      </div>
    </div>
  </div>

  <!--    <label for="email-input">Address</label>-->
  <!--    <span class="required"></span>-->
  <!--    <app-google-places-autocomplete [data]="userInfo?.address"></app-google-places-autocomplete>-->


  <div class="modal-footer">
    <button  *ngIf="!simpleEdit" class="save btn btn-dark" type="submit">{{ saveButtonLabel }}</button>
  </div>
</form>
